module.exports = __webpack_public_path__ + "media/img/video-play-dc34cc9c99e935cd9c88c036e34103f5.png";